import { useDispatch, useSelector } from 'react-redux'
import { type RootState } from '../Store/Store'
import { useCallback } from 'react'
import { setMissingLocalization } from '../Store/InterfaceSlice'

export function useLocalization(section: string): Localization {
  const dispatch = useDispatch()
  const localization = useSelector(
    (state: RootState) => state.interface.localization
  )

  const text = useCallback(
    (key: string, text: string, parameters?: Record<string, string>) => {
      let localizedText = text
      if (localization[section]?.[key] === undefined) {
        const parameterKeys = Object.keys(parameters ?? {})
        dispatch(
          setMissingLocalization({
            section,
            key,
            text,
            parameters: parameterKeys.length ? parameterKeys : undefined,
          })
        )
      } else {
        localizedText = localization[section][key].text
      }
      if (parameters && Object.keys(parameters).length) {
        for (const parameterKey in parameters) {
          const parameterValue = parameters[parameterKey]
          localizedText = localizedText.replaceAll(
            '{' + parameterKey + '}',
            parameterValue
          )
        }
      }
      return localizedText
    },
    [localization, section, dispatch]
  )

  return { text }
}

export interface Localization {
  text: (
    key: string,
    text: string,
    parameters?: Record<string, string>
  ) => string
}
